function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.54429 4.82857C6.54429 3.92857 6.63429 3.44714 7.99429 3.44714H9.81286V0H6.90286C3.41 0 2.17857 1.67286 2.17857 4.48429V6.55286H0V10H2.17857V20H6.53857V10H9.44714L9.83286 6.55286H6.53857L6.54429 4.82857Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/facebook.12bf6cda.svg";
export { SvgComponent as ReactComponent };